<template>
  <EmailConfirmationModal
    :additionalText="additionalText"
    :bodyText="bodyText"
    :cancelText="cancelText"
    :confirmationText="confirmationText"
    :defaultInputValue="defaultInputValue"
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    :headerText="headerText"
    :loading="loading"
    @input="handleChangeEvent"
  />
</template>
<script>

import * as Constants from 'client/util/Constants';
import { mapActions } from 'vuex';
import { notify } from 'client/util';
import EmailConfirmationModal from 'client/systemusers/Modals/EmailConfirmationModal.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import Util from 'client/util/Util';

const {
  ItemTypeConsts,
  ItemTypeRoutes,
  StoreModelMap,
} = Constants;

const { error, success } = Constants.default;

const systemUserModel = StoreModelMap[ItemTypeConsts.systemUser];

export default {
  name: 'ActivationEmailConfirmationModal',

  components: {
    EmailConfirmationModal,
  },

  ModalEventBus,

  notify,

  props: {
    additionalText: {
      default: '',
      type: String,
    },
    cancelText: {
      default: 'cancel',
      type: String,
    },
    closeAsideOnSubmit: {
      default: true,
      type: Boolean,
    },
    defaultInputValue: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      activationEmail: '',
      loading: false,
      successMessage: 'Activation email sent successfully!',
      errorMessage: 'There was an error sending the activation email. Please try again. If problem persists, please contact support.',
      bodyText: 'Please confirm the email address you would like to send JumpCloud’s activation email to. This email will allow this user to access the user portal and gain access to their assigned resources.',
      headerText: 'Activation Email',
      confirmationText: 'Activation Email Destination',
    };
  },

  beforeDestroy() {
    this.resetItem();
  },

  mounted() {
    this.fetchItem();
    this.handleChangeEvent(this.defaultInputValue);
  },

  methods: {
    ...mapActions(systemUserModel, [
      'fetchItem',
      'resetItem',
      'sendEmail',
    ]),

    handleCancel() {
      this.handleFinish();
    },

    async handleChangeEvent(val) {
      this.activationEmail = val;
    },

    async handleContinue() {
      this.loading = true;
      try {
        await this.sendEmail(this.activationEmail);
        this.$options.notify(success, this.successMessage);
      } catch {
        this.$options.notify(error, this.errorMessage);
      }
      this.loading = false;
      this.handleFinish();
    },

    handleFinish() {
      this.$options.ModalEventBus.close();
      if (this.closeAsideOnSubmit) {
        Util.redirect(ItemTypeRoutes[ItemTypeConsts.systemUser]);
      }
    },
  },
};
</script>
